import { OldLoadsRoute } from './oldLoads';

const LoadboardRoute = {
  path: '/loadboard',
  load: () => import('./Loadboard'),
  protected: true,
};

export { LoadboardRoute, OldLoadsRoute };
